export default "__VITE_ASSET__1geVPOKY__"